<kodit-page [showCardBlock]="showCardBlock">
    <kodit-table
      [tableConfig]="tableConfig"
      [items]="tekuciRacunTable"
    >
    </kodit-table>
  </kodit-page>
